import React, { createContext, useContext, useState, useCallback } from "react";
import { CohortStateContext } from '../../../components/CohortSelectorState/CohortStateContext';

const CohortAnalyzerContext = createContext();

export const useCohortAnalyzer = () => {
    return useContext(CohortAnalyzerContext);
}

export const CohortAnalyzerProvider = ({ children }) => {
    //cohort modal context
    const { state } = useContext(CohortStateContext);

    // states
    const [deleteInfo, setDeleteInfo] = useState({ showDeleteConfirmation: false, deleteType: '', cohortId: '' });
    const [nodeIndex, setNodeIndex] = useState(0);
    const [cohortList, setCohortList] = useState(Object.keys(state) || {});
    const [selectedCohorts, setSelectedCohorts] = useState([]);
    const [queryVariable, setQueryVariable] = useState({});
    const [rowData, setRowData] = useState([]);
    const [refreshInit, setRefreshInit] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [selectedChart, setSelectedChart] = useState([]);
    const [refreshSelectedChart, setRefreshSelectedChart] = useState(false);
    const [refreshTableContent, setRefreshTableContent] = useState(false);
    const [selectedCohortSection, setSelectedCohortSections] = useState([]);
    const [alert, setAlert] = useState({ type: '', message: '' });
    const [generalInfo, setGeneralInfo] = useState({});
    const [cohortData, setCohortData] = useState();
    const [showNavigateAwayModal, setShowNavigateAwayModal] = useState(false);



    //event handlers
    const handleCheckbox = (cohort, self) => {
        if (selectedCohorts.includes(cohort)) {
            let finalCohortList = [];
            selectedCohorts.forEach((cohortItem) => {
                if (cohort !== cohortItem) {
                    finalCohortList.push(cohortItem);
                }
            })
            setSelectedCohorts(finalCohortList)
        } else {
            if (selectedCohorts.length === 3) {
                self.preventDefault();
            } else {
                setSelectedCohorts([...selectedCohorts, cohort])
            }
        }

    }

    /** Clears Venn selections, table rows from Venn, and related filters (used with layout reset). */
    const resetVennWorkspaceUi = useCallback(() => {
        setNodeIndex(0);
        setSelectedChart([]);
        setSelectedCohortSections([]);
        setRowData([]);
        setGeneralInfo({});
        setRefreshSelectedChart((v) => !v);
    }, []);

    const contextValue = {
        deleteInfo,
        setDeleteInfo,
        nodeIndex,
        setNodeIndex,
        cohortList,
        setCohortList,
        handleCheckbox,
        selectedCohorts,
        setSelectedCohorts,
        queryVariable,
        setQueryVariable,
        rowData,
        setRowData,
        refreshInit,
        setRefreshInit,
        searchValue,
        setSearchValue,
        selectedChart,
        setSelectedChart,
        refreshSelectedChart,
        setRefreshSelectedChart,
        refreshTableContent,
        setRefreshTableContent,
        selectedCohortSection,
        setSelectedCohortSections,
        alert,
        setAlert,
        generalInfo,
        setGeneralInfo,
        cohortData,
        setCohortData,
        showNavigateAwayModal,
        setShowNavigateAwayModal,
        resetVennWorkspaceUi,
    };

    return (
        <CohortAnalyzerContext.Provider value={contextValue}>
            {children}
        </CohortAnalyzerContext.Provider>
    );
}